import { WorkPacketType } from "src/pages/UserDashboard/WorkPackets/WorkPacketType";

export const WORK_PACKET_SUPERVISOR_PERMISSIONS: Record<WorkPacketType, string[]> = {
  [WorkPacketType.SHORTAGES]: ["admin:*", "user:shortages_work_packet:supervisor:*"],
  [WorkPacketType.CHARGEBACKS]: ["admin:*", "user:chargebacks_work_packet:supervisor:*"],
  [WorkPacketType.ACCRUALS]: ["admin:*", "user:accruals_work_packet:supervisor:*"],
};

export const ALL_SUPERVISOR_PERMISSIONS: string[] = [
  "user:shortages_work_packet:supervisor:*",
  "user:chargebacks_work_packet:supervisor:*",
  "user:accruals_work_packet:supervisor:*",
  "user:shortages_case:supervisor:*",
  "user:chargebacks_case:supervisor:*",
];
